import { createPaginator } from "@smithy/core";
import { ListDatasetEntriesCommand, } from "../commands/ListDatasetEntriesCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateListDatasetEntries = createPaginator(RekognitionClient, ListDatasetEntriesCommand, "NextToken", "NextToken", "MaxResults");
